import clsx from 'clsx'
import { FC, PropsWithChildren } from 'react'

type ContainerProps = {
  className?: string
}

type LabelProps = {
  isRequired?: boolean
  className?: string
}

type GroupProps = {
  size?: 'sm' | 'md' | 'lg'
  variant?: 'solid' | 'outline'
}

type HelperTextProps = {}

type GroupTextProps = {}

type ErrorMessageProps = {
  message: string | undefined
}

const Container: FC<PropsWithChildren<ContainerProps>> = ({ className, children }) => {
  return <div className={clsx(className, 'mb-7')}>{children}</div>
}

const Group: FC<PropsWithChildren<GroupProps>> = ({ children, size, variant = 'solid' }) => {
  return (
    <div
      className={clsx('input-group', {
        [`input-group-${size}`]: !!size,
        'input-group-solid': variant === 'solid',
      })}
    >
      {children}
    </div>
  )
}

const GroupText: FC<PropsWithChildren<GroupTextProps>> = ({ children }) => {
  return <div className="input-group-text">{children}</div>
}

const HelperText: FC<PropsWithChildren<HelperTextProps>> = ({ children }) => {
  return <div className="form-text">{children}</div>
}

const Label: FC<PropsWithChildren<LabelProps>> = ({ isRequired, children, className }) => {
  return <div className={clsx(className, 'form-label', { required: isRequired })}>{children}</div>
}

const ErrorMessage: FC<ErrorMessageProps> = ({ message }) => {
  if (message) {
    return <div className="invalid-feedback d-block">{message}</div>
  }
  return null
}

const FormControl = Object.assign(Container, {
  Group,
  GroupText,
  Label,
  HelperText,
  ErrorMessage,
})

export default FormControl
